import CallServer from '../../api/CallServerV2';
import FileServer from '../../api/FileServer';

export async function fetchSubjects(params = {}) {
    return await CallServer({
        params: params,
        endpoint: '/admin/get_subjects',
        isGet: true
    })
}

export async function searchSubjects(pattern) {
    return await CallServer({
        params: { pattern },
        endpoint: '/admin/search_subjects',
        isGet: true
    })
}

export async function fetchCreateSubject(subject_data) {
    return await CallServer({
        body: subject_data,
        endpoint: '/admin/add_new_subject',
    })
}

export async function fetchEditSubject(subject_id, subject_data) {
    return await CallServer({
        params: { subject_id },
        body: subject_data,
        endpoint: '/admin/edit_subject',
    })
}

export async function fetchTopics(params = {}) {
    return await CallServer({
        params: params,
        endpoint: '/admin/get_topics',
        isGet: true
    })
}

export async function searchTopics(pattern) {
    return await CallServer({
        params: { pattern },
        endpoint: '/admin/search_topics',
        isGet: true
    })
}

export async function fetchCreateTopic(topic_data) {
    return await CallServer({
        body: topic_data,
        endpoint: '/admin/add_new_topic',
    })
}

export async function fetchEditTopic(topic_id, topic_data) {
    return await CallServer({
        params: { topic_id },
        body: topic_data,
        endpoint: '/admin/edit_topic',
    })
}

export async function fetchQuestions(params = {}) {
    return await CallServer({
        params: params,
        endpoint: '/admin/get_questions',
        isGet: true
    })
}

export async function fetchQuestionById(question_id) {
    return await CallServer({
        params: { question_id },
        endpoint: '/admin/get_question',
        isGet: true
    })
}

export async function fetchQuestionCountByTopicId(topic_id) {
    return await CallServer({
        params: { topic_id },
        endpoint: '/admin/get_num_questions_by_topic_id',
        isGet: true
    })
}

export async function fetchQuestionCountsByTopicIds(topic_ids = []) {
    const results = await Promise.all(topic_ids.map(topic_id => fetchQuestionCountByTopicId(topic_id)))
    const counts = {}
    topic_ids.forEach((topic_id, i) => {
        counts[topic_id] = results[i]?.success ? (results[i].data?.question_count || 0) : 0
    })
    return { success: true, data: counts }
}

export async function fetchCreateQuestion(question_data) {
    return await CallServer({
        body: question_data,
        endpoint: '/admin/add_new_question',
    })
}

export async function fetchEditQuestion(question_data) {
    return await CallServer({
        body: question_data,
        endpoint: '/admin/edit_question',
    })
}

export async function fetchDownloadQuestionBank(params = {}) {
    return await FileServer({
        params: params,
        isGet: true,
        endpoint: '/admin/download_questions_to_excel',
    })
}

export async function fetchDownloadSubjectsAndTopics() {
    return await FileServer({
        isGet: true,
        endpoint: '/admin/download_subjects_and_topics_to_excel',
    })
}

export async function fetchDeleteQuestion(question_id, force_delete = false) {
    return await CallServer({
        params: { question_id, force_delete },
        endpoint: '/admin/delete_question',
    })
}

export async function fetchDeleteTopic(topic_id, force_delete = false) {
    return await CallServer({
        params: { topic_id, force_delete },
        endpoint: '/admin/delete_topic',
    })
}

export async function fetchDeleteSubject(subject_id, force_delete = false) {
    return await CallServer({
        params: { subject_id, force_delete },
        endpoint: '/admin/delete_subject',
    })
}
